module.exports = __webpack_public_path__ + "static/media/desert-crossroads-disabled.c4aec2eb.png";